import {Props} from './model';
import {TouchableOpacity, View} from 'react-native';
import React from 'react';
import {Button} from '../../../../shared/components/button';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {openExternalLink} from '../../../../shared/pipes/openExternalLinks';
import {Html} from '../../../../shared/components/html';
import {Text} from '../../../../shared/components/text';

export default ({content, onPressHistoryLink}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: mediaOnly(
      DeviceSize.desktop,
      {
        flexDirection: 'row',
        alignItems: 'stretch',
      },
      {},
    ),
    textWrapper: mediaOnly(
      DeviceSize.desktop,
      {
        flex: 1,
        paddingRight: 33,
      },
      {
        marginBottom: 20,
      },
    ),
    textBaseFont: {
      color: theme.color.gray500,
      ...mediaOnly(DeviceSize.desktop, {}, theme.fonts.bodySmallLight),
    },
    buttonWrapper: {
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      ...mediaOnly(
        DeviceSize.desktop,
        {
          borderLeftColor: theme.color.borderColor,
          borderLeftWidth: 1,
          borderStyle: 'solid',
          flexBasis: 227,
          paddingLeft: 33,
          paddingVertical: 6,
        },
        {},
      ),
    },
    text: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.bodySmallLight},
        {
          ...theme.fonts.bodySmallLight,
        },
      ),
      color: theme.color.textColor,
    },
    link: {
      color: theme.color.linkColor,
    },
    button: {
      margin: 0,
      ...mediaOnly(DeviceSize.mobile, {width: '100%'}),
      ...mediaOnly(DeviceSize.tablet, {width: 328}),
    },
    historyButton: {
      ...mediaOnly(DeviceSize.mobile, {marginTop: 30}, {marginTop: 16}),
      color: theme.color.primaryColor,
    },
  }));
  return (
    <View style={styles.container}>
      <View style={styles.textWrapper}>
        <Html
          baseFontStyle={styles.textBaseFont}
          content={content.services.transportService.nonFinancial.eCardReplenishmentTipsHtml}
          testID='eCard-replenishment-tips'
        />
      </View>
      <View style={styles.buttonWrapper}>
        <Button
          id='replenishment-charge'
          onPress={() => openExternalLink(content.services.transportService.nonFinancial.eCardReplenishmentLink)}
          block={true}
          style={styles.button}
          type='primary'
          text='Пополнить карту'
        />
        <TouchableOpacity testID='replenishment-history' onPress={onPressHistoryLink}>
          <Text style={styles.historyButton} type='action' {...{dataSet: {class: 'link-filled'}}}>
            История пополнений
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};
